import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default",
  "use": "default-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"default\"><defs><style></style></defs><path d=\"M236.308 262.564h446.359v26.257h-446.36v-26.257zM236.308 498.872h446.359v26.256h-446.36v-26.256zM236.308 735.18h446.359v26.256h-446.36v-26.257zM722.051 262.564h65.641v26.257h-65.64v-26.257zM722.051 498.872h65.641v26.256h-65.64v-26.256zM722.051 735.18h65.641v26.256h-65.64v-26.257z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol